import { render, staticRenderFns } from "./DiscountCode.vue?vue&type=template&id=0b299b4b&scoped=true"
import script from "./DiscountCode.vue?vue&type=script&lang=js"
export * from "./DiscountCode.vue?vue&type=script&lang=js"
import style0 from "./DiscountCode.vue?vue&type=style&index=0&id=0b299b4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b299b4b",
  null
  
)

export default component.exports